import React from 'react';
import Chevron from './iconsTemporary/chevronAlert';
import './ids-alert.scss';

/**
 * @property {string} [type] -'success'| 'error'| 'attention | 'info'
 * @property { ReactElement} [icon]
 * @property {string} [title]
 * @property { HTMLCollection} [status]
 * @property { HTMLCollection} [ lastUpdated]
 * @property {boolean} [opend]  - isOpend expandable
 * @property {function} [setItem] -togglar expandable
 * @property {string} [variant] -'compact' | 'ribbon'
 * @property {string} [infoData] - Optional description text.
 * @property {boolean} [isExpandable]
 * @property {string} [infoData] - Optional description text.
 */
export const IDSExpandableAlert = (props) => {
  const {
    type,
    icon,
    details,
    title,
    status,
    lastUpdated,
    opened,
    setOpened,
    variant,
    isExpandable,
    infoData,
    statusName,
  } = props;

  return (
    <div
      aria-live="assertive"
      className={`ids-alert ids-alert--${type} ids-alert--${variant} ${
        !opened ? 'ids-alert--collapsed' : ''
      } `}
    >
      {!variant && <div className="ids-alert__content__icon">{icon}</div>}
      {title && !variant && (
        <div className="ids-alert__headline">
          <h3>{title}</h3>
        </div>
      )}
      {variant && (
        <div className="ids-alert__content">
          <div className="ids-alert__content__icon">{icon}</div>
          <div className="ids-alert__content__text">{title}</div>
        </div>
      )}
      {infoData && <div className="ids-alert__content__text">{infoData}</div>}
      {isExpandable && (
        <div className="ids-alert__button">
          <button
            onClick={() => {
              setOpened();
            }}
            className="ids-alert__expand"
            aria-controls="alert-content"
            aria-expanded={opened ? 'true' : 'false'}
            aria-label={
              opened
                ? `${title} Minimera alertmeddelande ${
                    type === 'error' && `${statusName}`
                  } `
                : `${title} Maximera alertmeddelande ${
                    type === 'attention' && `${statusName}`
                  } `
            }
          >
            {!opened ? (
              <Chevron
                transform={'rotate(180)'}
                ariaLabelText={'Pil upp, visa mindre information'}
              />
            ) : (
              <Chevron ariaLabelTex={'Pil ner, visa mer information'} />
            )}
          </button>
        </div>
      )}
      {opened && isExpandable && (
        <div className="ids-alert__content" aria-live="assertive" role="alert">
          {status && <div className="ids-alert__content__text">{status}</div>}
          {lastUpdated && (
            <div className="ids-alert__content__text">{lastUpdated}</div>
          )}
          {details && (
            <div className="ids-alert__content__text">
              Detaljerad information:{details}
            </div>
          )}
        </div>
      )}
    </div>
  );
};
